import {BehaviorSubject, Subject, filter, switchMap, throttleTime} from 'rxjs';
import {mockUtil} from '@px/helper/moc';
import {mc} from '@px/helper/mc';
import {assetsApi} from '@px/api/assets';
import {wwData$} from '../worker-data';

export const loadAssetsOverviewData$ = new Subject<void>();
const data$ = new BehaviorSubject<AssetsData>(null);

data$.subscribe((o) => {
  wwData$.next({
    type: 'assets',
    data: o,
  });
});

if (!mockUtil.isMock()) {
  loadAssetsOverviewData$.pipe(throttleTime(200), switchMap(getAssets), filter(Boolean)).subscribe(data$);
}

async function getAssets(): Promise<AssetsData | null> {
  const {data, error} = await assetsApi.getDataAssetsOverview({includeSub: false, includeFiat: true, includeMeme: true});
  if (error) {
    mc.send('toast', 'error', error);
    return {
      userId: 0,
      includeSub: true,
      includeFiat: true,
      usdTotalAssets: '0',
      usdtTotalAssets: '0',
      btcTotalAssets: '0',
      localCurrency: '0',
      localCcyTotalAssets: '0',
      timestampMill: '0',
      expiredTimeMill: '0',
      details: [],
    };
  }
  return data;
}
